import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import RoleGuard from "@/components/RoleGuard";
import ChatbotWidget from "@/components/ChatbotWidget";
import RouteSponsoredAd from "@/components/RouteSponsoredAd";
import HomePage from "@/pages/HomePage";
import JobsPage from "@/pages/JobsPage";
import JobDetailPage from "@/pages/JobDetailPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import EmployerPlansPage from "@/pages/EmployerPlansPage";
import PendingApprovalPage from "@/pages/PendingApprovalPage";
import CandidateDashboard from "@/pages/CandidateDashboard";
import EmployerDashboard from "@/pages/EmployerDashboard";
import PostJobPage from "@/pages/PostJobPage";
import AdminDashboard from "@/pages/AdminDashboard";
import PublicCareerPage from "@/pages/PublicCareerPage";
import InboxPage from "@/pages/InboxPage";
import { AboutPage, PricingPage, ContactPage, TermsPage, PrivacyPage } from "@/pages/StaticPages";
import { CategoryLandingPage, CityLandingPage, CategoriesIndexPage, CitiesIndexPage } from "@/pages/SeoLandingPages";
import LegacyCityRedirect from "@/components/LegacyCityRedirect";

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="min-h-screen flex flex-col bg-white">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/jobs" element={<JobsPage />} />
                <Route path="/jobs/categories" element={<CategoriesIndexPage />} />
                <Route path="/jobs/locations" element={<CitiesIndexPage />} />
                <Route path="/jobs/category/:slug" element={<CategoryLandingPage />} />
                <Route path="/jobs/location/:slug" element={<CityLandingPage />} />
                <Route path="/jobs/in/:slug" element={<LegacyCityRedirect />} />
                <Route path="/jobs/:slugPrefix/:slugSuffix" element={<JobDetailPage />} />
                <Route path="/jobs/:id" element={<JobDetailPage />} />
                <Route path="/career/:employerId" element={<PublicCareerPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/register/employer/plans" element={<EmployerPlansPage />} />
                <Route path="/pending-approval" element={<PendingApprovalPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/inbox" element={<RoleGuard roles={["candidate", "employer", "admin"]}><InboxPage /></RoleGuard>} />
                <Route path="/candidate" element={<RoleGuard roles={["candidate"]}><CandidateDashboard /></RoleGuard>} />
                <Route path="/employer" element={<RoleGuard roles={["employer"]}><EmployerDashboard /></RoleGuard>} />
                <Route path="/employer/post" element={<RoleGuard roles={["employer"]}><PostJobPage /></RoleGuard>} />
                <Route path="/admin" element={<RoleGuard roles={["admin"]}><AdminDashboard /></RoleGuard>} />
              </Routes>
            </main>
            <Footer />
            <ChatbotWidget />
            <RouteSponsoredAd />
            <Toaster position="top-right" richColors />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
